// import pin from "../../images/map-pin.png";

export default (theme) => ({
  InfoWindow: {
    position: 'absolute',
    top: -34,
    left: -11,
    width: 220,
    backgroundColor: 'white',
    color: '#000',
    boxShadow: '0 2px 7px 1px rgba(0, 0, 0, 0.3)',
    padding: 16,
    fontSize: 14,
    zIndex: 100,
    cursor: "initial",
    borderTopLeftRadius: 10,
    borderBottomRightRadius: 10,
    '& button': {
      background: 'transparent',
      width: 44,
      height: 44,
      borderRadius: 22,
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      fontSize: 0,
      position: 'absolute',
      top: -22,
      right: -22,
      boxShadow: '0 2px 7px 1px rgba(0, 0, 0, 0.3)',
      border: 'none',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 12,
        left: 12,
        width: 20,
        height: 20,
        background: theme.palette.common.white,
        clipPath: 'polygon(20% 0%, 0% 20%, 30% 50%, 0% 80%, 20% 100%, 50% 70%, 80% 100%, 100% 80%, 70% 50%, 100% 20%, 80% 0%, 50% 30%)',
      }
    },
    '& h3': {
      fontSize: 16,
      marginTop: 0,
      letterSpacing: '0.05em',
      fontFamily: 'Overpass',
      color: theme.palette.primary.main,
    },
    '& p': {
      fontSize: 14,
      letterSpacing: '0.066em',
      lineHeight: 1.5,
    },
    '& a': {
      fontFamily: 'Bebas Neue',
      color: theme.palette.secondary.main,
      textDecoration: 'none',
      textTransform: 'uppercase',
      fontSize: 16,
    }
  },
});
